import { useMutation } from '@apollo/client';
import { deleteChargeCode as deleteChargeCodeGqlMutation } from 'graphql-queries';

import {
  GroupType,
  DeleteChargeCodeRequest
} from 'graphql-query-contracts';

export function useDeleteChargeCodeMutation() {
  const [deleteChargeCode, { loading, error }] = useMutation<
    { deleteChargeCode: null },
    { deleteChargeCodeRequest: DeleteChargeCodeRequest }
  >(deleteChargeCodeGqlMutation);

  const deleteChargeCodeMutation = async (
    chargeCodeId: string,
    channelId: string
  ): Promise<void> => {
    await deleteChargeCode({
      variables: {
        deleteChargeCodeRequest: {
          id: chargeCodeId,
          groupType: GroupType.GroupTypeActivateChannel,
          groupId: channelId,
        },
      },
    });
  };

  return {
    deleteChargeCodeMutation,
    loading,
    error,
  };
}
